export default __webpack_public_path__ + "09d2d0944c37161b611f5368ce72541d.png";